export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#81C784] text-white py-12 sm:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-12 sm:mb-16">
          <div className="space-y-4 sm:space-y-6 text-center sm:text-left">
            <img
              alt="ぽかぽか堂 よりみち相談室"
              className="h-14 sm:h-16 lg:h-18 w-auto mx-auto sm:mx-0"
              src="https://static.readdy.ai/image/e68483200b29d1db925b252765737b7b/d42e6993fa69380b98ac51f79be2a451.png"
            />
            <p className="text-sm sm:text-base text-white/90 leading-relaxed">
              地域密着型の伴走サポート。<br />あなたのペースで、一緒に。
            </p>
          </div>
          <div className="text-center sm:text-left">
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">クイックリンク</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  サービス内容
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('plans')}
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  料金プラン
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm sm:text-base text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  ご予約
                </button>
              </li>
            </ul>
          </div>
          <div className="text-center sm:text-left">
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">お問い合わせ</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-center gap-3 text-sm sm:text-base text-white/90 justify-center sm:justify-start">
                <i className="ri-phone-line text-lg sm:text-xl"></i>
                <a href="tel:048-992-2286" className="hover:text-white transition-colors">
                  048-992-2286
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm sm:text-base text-white/90 justify-center sm:justify-start">
                <i className="ri-mail-line text-lg sm:text-xl"></i>
                <a href="mailto:nao6091970@gmail.com" className="hover:text-white transition-colors">
                  nao6091970@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm sm:text-base text-white/90 justify-center sm:justify-start">
                <i className="ri-map-pin-line text-lg sm:text-xl"></i>
                <span>
                  〒343-0111<br className="sm:hidden" />埼玉県北葛飾郡松伏町<br className="sm:hidden" />松伏1999-6
                </span>
              </li>
            </ul>
          </div>
          <div className="text-center sm:text-left">
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">SNS</h4>
            <div className="flex gap-4 justify-center sm:justify-start">
              <a
                href="https://lin.ee/X9AgMBj"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-all cursor-pointer"
              >
                <i className="ri-line-fill text-xl sm:text-2xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl sm:text-2xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl sm:text-2xl"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-6 sm:pt-8">
          <div className="text-center mb-4 sm:mb-6">
            <h4 className="text-base sm:text-lg font-bold mb-3">事業者情報</h4>
            <div className="space-y-1 text-xs sm:text-sm text-white/90">
              <p>事業者名：ぽかぽか堂「よりみち相談室webサポート」</p>
              <p>代表者：今野直子</p>
            </div>
          </div>
          <div className="text-center">
            <p className="text-xs sm:text-sm text-white/80">
              © 2024 ぽかぽか堂 よりみち相談室. All rights reserved. |
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors ml-1"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
